import { FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

interface CreateDropdownInputProps {
  label: string,
  options: string[],
  stateName: any,
  setStateFunction: Function,
  preValue: string,
  option?: any,
  disabled?: boolean,
  loading?: boolean,
}

const GGDropdownInput = (props: CreateDropdownInputProps) => {
  const {
    label,
    options,
    stateName,
    setStateFunction,
    preValue,
    option,
    disabled,
    loading = false,
  } = props;

  const [data, setData] = useState('')

  const handleChange = (event:any, stateName:any, option:any) => {
    setData(event.target.value as string);
    setStateFunction(event.target.value, stateName, option)
  };

  const shouldDisable = (items:string[]) => {
    if(items && items.length > 0) {
      if(items.length === 1 && items[0] === "") return true;
      return false
    }
    return true
  }

  useEffect(() => {
    handleChange({target: {value: preValue}}, stateName, option)
  },
  // eslint-disable-next-line
  [preValue])

  return (
    <FormControl fullWidth disabled={disabled} style={{ position: "relative" }}>
      <InputLabel id="demo-simple-select-label">{label}*</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        disabled={shouldDisable(options) || loading}
        value={data}
        label={label}
        onChange={e => handleChange(e, stateName, option)}
      >
        {
          options.map((i, index) => (
            <MenuItem key={index} value={i}>{i}</MenuItem>
          ))
        }
      </Select>
      {loading && (
        <CircularProgress
          size={18}
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            marginTop: -9,
          }}
        />
      )}
    </FormControl>
  )
}

export default GGDropdownInput